import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import TableDescriptors from '../../../definitions/tableDescriptors';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import EntityTableTooling from '../../../tooling/entityTableTooling';
import { intl } from '../../../locales/localesConfig';

/* Actions */
import * as endpointsConnectorsAdminActions from '../../actions/endpointsConnectorsAdmin/index';
import * as dashboardActions from '../../actions/dashboard/index';

/*Components*/
import FullScreenGlassLoading from '../../components/common/interface/fullScreenGlassLoading';
import EntityHeader from '../../components/common/entity/entityHeader';
import EntityTable from '../../components/common/entity/entityTable';
import FormPopup from '../../components/endpointsconnectorsAdmin/formPopup'
import GlassConfirmPopup from '../../components/common/interface/glassConfirmPopup';
import ErrorLoadingView from '../../components/common/interface/errorLoadingView';

const popupIds = {
  formPopup: "formPopup",
  deleteConfirmPopup: "deleteConfirmPopup",
  activeConfirmPopup: "activeConfirmPopup",
  closeFormConfirmPopup: "closeFormConfirmPopup",
}

class EndpointsConnectorsAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topControlsFormData: {
        searchText: '',
        showDisabledEntities: false
      },
      searchTimeoutObject: null,
      tableDescriptor: TableDescriptors.endpointsConnectorsList,
      entityApiKey: "endpoint_connector",
      initialNewEntity: {
        name: "", endpoint_url : "", endpoint_method: "", endpoint_headers: [], endpoint_params: [],
        connector_calculation_unit: [], connector_metric_value: [], endpoint_connector_mapping: [], endpoint_return_data_path: "", endpoint_return_inner_data_path: "",
        connector_schedule: "", connector_schedule_period_date: "", connector_schedule_date_formula: "", connector_schedule_time: "", connector_schedule_recurrent_formula: "",
        endpoint_connector_type: "", connector_login_token_variable_id: "", connector_calculation_units_user_id: "", connector_metric_values_metric_group_id: "",
        connector_metric_values_iterate_calculation_units: false, connector_metric_values_ignore_calculation_unit: true,
        output_connectors_has_return_data: false, connector_calculations_send_only_reprocess_delta: false, input_connectors_is_csv_numbers_format: false,
        connector_calculation_units_ignore_invalid_groups: false, connector_calculations_model_code_dimension_id: "",
        connector_metric_values_ignore_period: true, connector_calculation_units_ignore_email: false,
        connector_calculation_units_ignore_duplicates: false, connector_schedule_stop_if_valid_execution: true, connector_metric_values_delete_metric_values: false,
        connector_calcualtion_unit_group_model_association_type: "", connector_cu_group_model_association_code_selector: "", exclude_calculation_units_unrollment: false,
      },
      activeMetricGroupSelected: "",
      formHasChanges: false,
    };
  }
 
  componentDidMount() {
    EntityTableTooling.fetchList(this);
    this.props.actions.getLoginTypeVariablesOptionsList();
    this.props.actions.getCalculationUnitTypeFieldsOptionsList();
    this.props.actions.getMetricValueTypeFieldsOptionsList();
    this.props.actions.getUsersList();
    this.props.actions.getDimensionsList();
  }
  
  componentWillUnmount() {
    this.props.actions.reset();
  }
  
  componentDidUpdate(prevProps) {
    EntityTableTooling.feedbackMessages(this, prevProps, 
      FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "endpointsConnectorsAdmin.entityNameSingularWithArticle"})),
      FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "endpointsConnectorsAdmin.entityNamePlural"})),
      intl.formatMessage({id: "endpointsConnectorsAdmin.genderVocal"}),
      (this.props.delete.errors.message ? intl.formatMessage({id: "common.errors.detailLabel"}) + this.props.delete.errors.message : ""),
      (this.props.save.errors.message ? intl.formatMessage({id: "common.errors.detailLabel"}) + this.props.save.errors.message : ""));

    InterfaceTooling.apiCallResultFeedback(
      [prevProps.externalFieldOptionsList.status],
      [this.props.externalFieldOptionsList.status],
      intl.formatMessage({id: "endpointsConnectorsAdmin.successLoadingExternalFields"}),
      intl.formatMessage({id: "endpointsConnectorsAdmin.errors.loadingExternalFields"}) +
      ((this.props.externalFieldOptionsList.data && this.props.externalFieldOptionsList.data.error) ? 
        FormatTooling.escapeHTML(" -> " + this.props.externalFieldOptionsList.data.error.substring(0, 500)) : ""),
      []    
    );
  }
  
  handleShowFormPopup = async (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.formPopup, this.state, 
      this.setState.bind(this), this.props.save.loading, () => {
        let entityObject = {};
        entityObject[this.state.entityApiKey] = JSON.parse(event.currentTarget.dataset.entitydata)
        this.props.actions.resetSaveEntity(entityObject);
        if(entityObject[this.state.entityApiKey]["connector_metric_values_metric_group_id"]) {
          this.setState({
            activeMetricGroupSelected: entityObject[this.state.entityApiKey]["connector_metric_values_metric_group_id"]
          });
        }
      }
    );
  };
  
  handleOnChangeForm = (event) => {
    if(event.currentTarget.dataset.paramseditor || event.currentTarget.dataset.headerseditor || event.currentTarget.dataset.connectormappingeditor) {
      let path = event.currentTarget.dataset.path;
      let index = event.currentTarget.dataset.index;
      let objectValue = JSON.parse(event.currentTarget.dataset.value);
      let isDelete = event.currentTarget.dataset.delete;
      let isEdit = event.currentTarget.dataset.edit;

      let objectDefinition = [];
      if(JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)) {
        objectDefinition = JavascriptUtilsTooling.deepCopy(
          JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)
        );
      }
      if(isDelete) {
        delete objectDefinition[index];
        objectDefinition = objectDefinition.filter(item => item);
      } 
      else if(isEdit) {
        objectDefinition[index] = objectValue;
      } 
      else {
        objectDefinition.push(objectValue);
      }
      this.props.actions.setSaveEntityDataByKey(path, objectDefinition);            
      this.setState({ formHasChanges: false });
    }
    else if(event.currentTarget.dataset.path == "endpoint_connector.connector_schedule"){
      this.props.actions.setSaveEntityDataByKey("endpoint_connector.connector_schedule_period_date", "");
      this.props.actions.setSaveEntityDataByKey("endpoint_connector.connector_schedule_date_formula", "");
      this.props.actions.setSaveEntityDataByKey("endpoint_connector.connector_schedule_time", "");
      this.props.actions.setSaveEntityDataByKey("endpoint_connector.connector_schedule_recurrent_formula", "");  
      EntityTableTooling.handleOnChangeForm(this, event);
    }
    else if(event.currentTarget.dataset.path == "endpoint_connector.endpoint_connector_type") {
      this.props.actions.setSaveEntityDataByKey("endpoint_connector.connector_login_token_variable_id", "");
      this.props.actions.setSaveEntityDataByKey("endpoint_connector.connector_calculation_units_user_id", "");
      this.props.actions.setSaveEntityDataByKey("endpoint_connector.connector_metric_values_metric_group_id", "");
      this.props.actions.setSaveEntityDataByKey("endpoint_connector.endpoint_connector_mapping", []);
      this.props.actions.setSaveEntityDataByKey("endpoint_connector.endpoint_connector_mapping_filter", []);
      this.props.actions.setSaveEntityDataByKey("endpoint_connector.connector_calculations_model_code_dimension_id", "");
      this.props.actions.setSaveEntityDataByKey("endpoint_connector.output_connectors_has_return_data", false);
      this.props.actions.setSaveEntityDataByKey("endpoint_connector.input_connectors_is_csv_numbers_format", false);
      this.props.actions.setSaveEntityDataByKey("endpoint_connector.exclude_calculation_units_unrollment", false);      
      this.props.actions.setSaveEntityDataByKey("endpoint_connector.connector_metric_values_iterate_calculation_units", false);
      this.props.actions.setSaveEntityDataByKey("endpoint_connector.connector_metric_values_ignore_calculation_unit", true);
      this.props.actions.setSaveEntityDataByKey("endpoint_connector.connector_calculations_send_only_reprocess_delta", false);
      this.props.actions.setSaveEntityDataByKey("endpoint_connector.connector_metric_values_ignore_period", true);
      this.props.actions.setSaveEntityDataByKey("endpoint_connector.connector_calculation_units_ignore_email", false);
      this.props.actions.setSaveEntityDataByKey("endpoint_connector.connector_calculation_units_ignore_duplicates", false);
      this.props.actions.setSaveEntityDataByKey("endpoint_connector.connector_metric_values_delete_metric_values", false);      

      if(event.currentTarget.value == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_reports_endpoint_type ||
        event.currentTarget.value == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_calculations_endpoint_type
      ) {
        this.props.actions.setSaveEntityDataByKey("endpoint_connector.endpoint_return_data_path", "");
        this.props.actions.setSaveEntityDataByKey("endpoint_connector.endpoint_return_inner_data_path", "");
      }
      this.setState({
        activeMetricGroupSelected: "",
      });
      this.props.actions.resetExternalFieldOptionsList();
      EntityTableTooling.handleOnChangeForm(this, event);
    }
    else if(event.currentTarget.dataset.path == "endpoint_connector.connector_metric_values_metric_group_id") {
      EntityTableTooling.handleOnChangeForm(this, event);
      if(event.currentTarget.value!="") {
        this.setDefaultConnectorMappingFields(this.props.metricValueTypeFieldsOptionsList.data.find(item => item.id==event.currentTarget.value).headers ,"endpoint_connector.endpoint_connector_mapping", false)
        this.setState({
          activeMetricGroupSelected: event.currentTarget.value
        });
      }
    }
    else {
      if(event.currentTarget.dataset.path == "endpoint_connector.output_connectors_has_return_data" &&
        JavascriptUtilsTooling.getInputValueFromEvent(event) == false
      ) {
        this.props.actions.setSaveEntityDataByKey("endpoint_connector.endpoint_return_data_path", "");
        this.props.actions.setSaveEntityDataByKey("endpoint_connector.endpoint_return_inner_data_path", "");
        this.props.actions.setSaveEntityDataByKey("endpoint_connector.connector_metric_values_metric_group_id", "");
        this.props.actions.setSaveEntityDataByKey("endpoint_connector.endpoint_connector_mapping", []);
        this.props.actions.setSaveEntityDataByKey("endpoint_connector.endpoint_connector_mapping_filter", []);
        this.props.actions.setSaveEntityDataByKey("endpoint_connector.input_connectors_is_csv_numbers_format", false);
      }
      if(event.currentTarget.dataset.path == "endpoint_connector.connector_calcualtion_unit_group_model_association_type"){
        this.props.actions.setSaveEntityDataByKey("endpoint_connector.connector_cu_group_model_association_code_selector", Constants.selectKeys.endpoint.connector_cu_group_model_association_code_selector.name);
      }
      EntityTableTooling.handleOnChangeForm(this, event);
    }    
  };

  handleShowFormPopupToClone = (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.formPopup, this.state, 
      this.setState.bind(this), (this.props.save.loading), () => {
        let entityObject = {};
        let parsedObject = JSON.parse(event.currentTarget.dataset.entitydata);
        entityObject[this.state.entityApiKey] = parsedObject
        entityObject["clone"] = true;
        delete entityObject[this.state.entityApiKey]["id"];
        this.props.actions.resetSaveEntity(entityObject);
        if(entityObject[this.state.entityApiKey]["connector_metric_values_metric_group_id"]) {
          this.setState({
            activeMetricGroupSelected: entityObject[this.state.entityApiKey]["connector_metric_values_metric_group_id"]
          });
        }
        this.setState({ formHasChanges: false });
      }
    );
  }

  setDefaultConnectorMappingFields = (fieldsList, path, checkValues = true, isAssociationConnectorMapping = false) => {
    // When the connector mapping component is loaded (or resetted), this function set's the default mapping fields in the list component.
    //    fieldsList: Array of strings with the fields to set
    //    path: Path to the mapping fields in the save reducer
    //    checkValues: If true, the function will check if the values are already setted, if so, it will not set the default one (this requires further dev testing)
    //    isAssociationConnectorMapping: If true, the function will not set the default fields, but will set the current mapping fields with the current values
    if(checkValues && JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path).length>0 && !isAssociationConnectorMapping) {      
      //Mark the coming fields as default when necessary
      let objectDefinition = JavascriptUtilsTooling.deepCopy(JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path))

      let remainingDefaultFields = JavascriptUtilsTooling.deepCopy(fieldsList)
      let manuallyAddedFields = []
      let newObjectDefinition = objectDefinition.map((item) => { 
        if(remainingDefaultFields.includes(item.mapping_field)) {
          remainingDefaultFields.splice(remainingDefaultFields.indexOf(item.mapping_field), 1);
          return {...item, isDefaultField: true};
        }
        else{
          manuallyAddedFields.push(item);
        }
      });
      newObjectDefinition = newObjectDefinition.filter(item => item);
      remainingDefaultFields.forEach(item => {
        newObjectDefinition.push({mapping_field: item, isDefaultField: true,})
      })
      manuallyAddedFields.forEach(item => {
        newObjectDefinition.push(item)
      })      

      this.props.actions.setSaveEntityDataByKey(path, newObjectDefinition);
      return
    }
    else if(!isAssociationConnectorMapping){
      let objectDefinition = [];
      if(fieldsList && fieldsList.length>0 && path){
        fieldsList.forEach((item, index) => {
          objectDefinition.push({
            mapping_field: item,
            isDefaultField: true,
          });
        });
        this.props.actions.setSaveEntityDataByKey(path, objectDefinition);
      }
    }
    else{
      let objectDefinition = [];
      let currentFields = JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path);
      if(fieldsList && fieldsList.length>0 && path){
        fieldsList.forEach((item) => {
          let currentField = currentFields.find(i => i.mapping_field == item)
          objectDefinition.push({
            mapping_field: item,
            isDefaultField: true,
            mapping_external_field: currentField ? currentField.mapping_external_field : "",
            mapping_path: currentField ? currentField.mapping_path : "",
            mapping_sufix: currentField ? currentField.mapping_sufix : "",
            mapping_prefix: currentField ? currentField.mapping_prefix : "",
            mapping_filter: currentField ? currentField.mapping_filter : "",
            mapping_ignore_path_errors: currentField ? currentField.mapping_ignore_path_errors : false,
            mapping_filter_nils: currentField ? currentField.mapping_filter_nils : false,
            mapping_fixed_value: currentField ? currentField.mapping_fixed_value : "",
          });
        });
        this.props.actions.setSaveEntityDataByKey(path, objectDefinition);
      }
    }
  }

  getExternalFieldOptionsList = async (event) => {
    this.props.actions.getExternalFieldOptionsList({
      endpoint_connector_id: JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, this.state.entityApiKey + ".id"),
    })
  };

  render() {
    var loadingView = this.props.list.firstLoading || this.props.loginTypeVariablesOptionsList.firstLoading || this.props.calculationUnitTypeFieldsOptionsList.firstLoading ||
      this.props.metricValueTypeFieldsOptionsList.firstLoading || this.props.usersList.firstLoading || this.props.dimensionsList.firstLoading;    
    var errorLoadingView = (this.props.list.status !== null && this.props.list.status !== 200) ||
      (this.props.loginTypeVariablesOptionsList.status !== null && this.props.loginTypeVariablesOptionsList.status !== 200) ||
      (this.props.calculationUnitTypeFieldsOptionsList.status !== null && this.props.calculationUnitTypeFieldsOptionsList.status !== 200) ||
      (this.props.metricValueTypeFieldsOptionsList.status !== null && this.props.metricValueTypeFieldsOptionsList.status !== 200) ||
      (this.props.usersList.status !== null && this.props.usersList.status !== 200) ||
      (this.props.dimensionsList.status !== null && this.props.dimensionsList.status !== 200);
    return (      
      <section className="dashboard_content_inner_view entity_admin_container endpoints_connectors_admin_container">
        {
          loadingView ? (<FullScreenGlassLoading/>) : 
          errorLoadingView ? (<ErrorLoadingView/>) :
          (
            <section>
               <EntityHeader 
                entityNamePlural={this.state.tableDescriptor.entityNamePlural}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
                handleFormPopup={EntityTableTooling.handleShowFormPopup.bind(null, this)}
                handleRefresh={EntityTableTooling.fetchList.bind(null, this)}
              />
              <EntityTable
                entityTableDescriptor={this.state.tableDescriptor}
                data={this.props.list.data}
                loading={this.props.list.loading}
                page={this.props.list.page}
                totalPages={this.props.list.totalPages}
                totalRecords={this.props.list.totalRecords}
                orderBy={this.props.list.orderBy}
                orderByDirection={this.props.list.orderByDirection}
                topControlsFormData={this.state.topControlsFormData}
                handleOnChangeTopControls={EntityTableTooling.handleOnChangeTopControls.bind(null, this)}
                fetchOrderList={EntityTableTooling.fetchListOrder.bind(null, this)}
                fetchListChangePage={EntityTableTooling.fetchListNextPage.bind(null, this)}
                handleShowFormPopup={this.handleShowFormPopup}
                handleDelete={EntityTableTooling.handleDeletePopup.bind(null, this)}
                handleActive={EntityTableTooling.handleActivePopup.bind(null, this)}
                handleCustomActions={[this.handleShowFormPopupToClone]}
                customActionsIcons={["clone"]}
                customActionsTooltips={[
                  intl.formatMessage({ id: "common.entityTableActions.clone"})
                ]}
              />
              <FormPopup
                handleShowPopup={EntityTableTooling.handleShowFormPopupWithConfirmOnExit.bind(null, this)}
                handleOnChangeForm={this.handleOnChangeForm}
                handleButton={EntityTableTooling.handleOnSaveForm.bind(null, this)}
                loadingButton={this.props.save.loading}
                fullLoading={this.props.save.loading || this.props.externalFieldOptionsList.loading}
                statusButton={this.props.save.status}
                formData={this.props.save.data}
                errors={this.props.save.errors}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
                popupState={EntityTableTooling.getFormPopupState(this)}
                calculationUnitTypeFieldsOptionsList={this.props.calculationUnitTypeFieldsOptionsList.data}
                metricValueTypeMetricGroupOptionsList={this.props.metricValueTypeFieldsOptionsList.data}
                handleSetDefaultConnectorMappingFields={this.setDefaultConnectorMappingFields}
                handleGetExternalFieldOptionsList={this.getExternalFieldOptionsList}
                externalFieldOptionsList={this.props.externalFieldOptionsList.data ? this.props.externalFieldOptionsList.data : []}
                loginTypeVariablesOptionsList={this.props.loginTypeVariablesOptionsList.data}
                metricValueTypeFieldsOptionsList={this.state.activeMetricGroupSelected ? 
                  (this.props.metricValueTypeFieldsOptionsList.data) : null}
                usersList={this.props.usersList.data}
                dimensionsList={this.props.dimensionsList.data}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                 id={"common.entity.deleteEntityConfirmTitle"}
                 values={{entityNameSingular: (<FormattedMessage id={"endpointsConnectorsAdmin.entityNameSingular"}/>)}}
                />)}
                confirmText={(<FormattedMessage 
                 id={"common.entity.deleteEntityConfirm"}
                 values={{entityNameSingular: (<FormattedMessage id={"endpointsConnectorsAdmin.entityNameSingularWithArticle"}/>)}}
                />)}
                handleConfirm={EntityTableTooling.handleDeleteConfirm.bind(null, this)}
                handleCancel={EntityTableTooling.handleDeletePopup.bind(null, this)}
                popupState={EntityTableTooling.getDeletePopupState(this)}
                loading={this.props.delete.loading}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                 id={"common.entity.activeEntityConfirmTitle"}
                 values={{
                    entityNameSingular: (<FormattedMessage id={"endpointsConnectorsAdmin.entityNameSingular"}/>),
                    activeAction: this.props.save.data.user && this.props.save.data.user.active ?
                      (<FormattedMessage id={"common.entity.activeAction"}/>) :
                      (<FormattedMessage id={"common.entity.deactiveAction"}/>)
                  }}
                />)}
                confirmText={(<FormattedMessage 
                 id={"common.entity.activeEntityConfirm"}
                 values={{
                    entityNameSingular: (<FormattedMessage id={"endpointsConnectorsAdmin.entityNameSingularWithArticle"}/>),
                    activeAction: this.props.save.data.user && this.props.save.data.user.active ?
                      (<FormattedMessage id={"common.entity.activeAction"}/>) :
                      (<FormattedMessage id={"common.entity.deactiveAction"}/>)
                  }}
                />)}
                handleConfirm={EntityTableTooling.handleActiveConfirm.bind(null, this)}
                handleCancel={EntityTableTooling.handleActivePopup.bind(null, this)}
                popupState={EntityTableTooling.getActivePopupState(this)}
                loading={this.props.save.loading}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage id={"common.confirmExitPopupTitle"}/>)}
                confirmText={(<FormattedMessage id={"common.confirmExitPopupDetail"}/>)}
                handleConfirm={InterfaceTooling.handleCloseForm.bind(null, this)}
                handleCancel={InterfaceTooling.handleCloseFormConfirmPopup.bind(null, this)}
                popupState={InterfaceTooling.getCloseFormConfirmPopupState(this)}
                loading={false}
              />
            </section>
          )
        }
      </section>
    );
  }
}

const mapStateToProps = state => ({
  list: state.reducer.endpointsConnectorsAdmin.list,
  save: state.reducer.endpointsConnectorsAdmin.save,
  delete: state.reducer.endpointsConnectorsAdmin.delete,
  loginTypeVariablesOptionsList: state.reducer.endpointsConnectorsAdmin.loginTypeVariablesOptionsList,
  calculationUnitTypeFieldsOptionsList: state.reducer.endpointsConnectorsAdmin.calculationUnitTypeFieldsOptionsList,
  externalFieldOptionsList: state.reducer.endpointsConnectorsAdmin.externalFieldOptionsList,
  metricValueTypeFieldsOptionsList: state.reducer.endpointsConnectorsAdmin.metricValueTypeFieldsOptionsList,
  usersList: state.reducer.endpointsConnectorsAdmin.usersList,
  dimensionsList: state.reducer.endpointsConnectorsAdmin.dimensionsList,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(endpointsConnectorsAdminActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch)
});

EndpointsConnectorsAdmin.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EndpointsConnectorsAdmin);



// WEBPACK FOOTER //
// ./source/client/containers/endpointsConnectorsAdmin/index.jsx